import { NgOptimizedImage } from '@angular/common';
import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, HostListener, Input, OnInit, Renderer2, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AsyncPipe } from '@angular/common';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { CommonService } from '../../../services/common.service';
import { CustomFlexLayoutModule } from '../../../flex-layout/custom-flex-layout.module';

@Component({
  selector: 'calsoft-ng-optimized-image',
  imports: [CustomFlexLayoutModule, NgOptimizedImage, LazyLoadImageModule],
  templateUrl: './ng-optimized-image.component.html',
  styleUrl: './ng-optimized-image.component.scss'
})
export class NgOptimizedImageComponent {
  @Input() width: any;
  type: number | undefined;
  get imageLarge(): string {
    return this.image.replace(/\.(jpg|png)$/, '-large.webp');
  }
  init = false;
  @Input() imageWidth: any = 800;  // Default width
  @Input() imageHeight: any = 600; // Default height

  @Input() height: any;

  @Input() i: any;

  @Input() heightMob: any;

  @Input() categoryId6: any;

  @Input() navigation: any;

  @Input() altImage: any;

  @Input() catId: any;

  @Input() navigatedUrl: any;

  @Input() customField9: any;

  @Input() image: any;

  defaultImage: any;


  @ViewChild('diceContainer') diceContainer!: ElementRef;

  ngAfterViewInit() {
    this.width = this.diceContainer?.nativeElement.offsetWidth;
    // Use this width as needed
  }


  display: any = false;
  get optimizedImage(): string {
    return this.image.replace(/\.(jpg|png)$/, '.webp');
  }
  get imageSrcSet(): string {
    return `${this.optimizedImage} 480w, ${this.image.replace(/\.(jpg|png)$/, '-large.webp')} 1024w`;
  }

  constructor(private commonService: CommonService, private cdr: ChangeDetectorRef,
    private renderer: Renderer2, private route: ActivatedRoute
  ) {


  }
  screen_lg = '1200px';
  screen_md = '992px';
  ngOnInit() {



    if (this.height === '' || this.height === null || this.height === undefined) {
      this.type = 2;
    } else {

      this.height = isNaN(this.height) ? this.height : `${this.height}px`;
      this.heightMob = isNaN(this.heightMob) ? this.heightMob : `${this.heightMob}px`;
      this.type = 1;
      this.init = true;
    }
    
    if (this.image) {
      this.preloadImage(this.image).then(() => {
        this.init = true;
      });
    }


    // this.updateHeight();
    // this.preloadImage(this.image);

    // this.defaultImage = this.image;
  }
  preloadImage(url: string): Promise<void> {
    return new Promise(resolve => {
      const img = new Image();
      img.src = url;
      img.onload = () => resolve();
      img.onerror = () => resolve(); // avoid hanging if image fails
    });
  }
  


  @HostListener('window:resize', [])
  onResize() {
    this.updateHeight();
  }

  updateHeight() {
    const width = window.innerWidth;

    if (width < 959) {
      this.imageHeight = this.heightMob || 500;

    } else {



      this.imageHeight = this.height || 700;

    }
    this.imageHeight = this.imageHeight?.toString().replace('px', '');


    this.display = true

    this.cdr.detectChanges();

  }



  goToCategories(id: any) {
    if (id > 0) {
      this.commonService.goToCategory(1, parseInt(id));
    }

  }


  link(url: any) {

    this.commonService.goToLink(url)
  }


}
